import { createSlice } from "@reduxjs/toolkit";
import { getReleaseDocListAPI } from "../../services/releaseDocAPIs";

const data = {
  isLoading: false,
  error: "",
  message: "",
  data: null,
  statusCode: undefined,
};

const getReleaseDocsSlice = createSlice({
  name: "getReleaseDocs",
  initialState: data,
  reducers: {
    getReleaseDocsInfo(state) {
      state.isLoading = true;
    },
    getReleaseDocsInfoSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = "";
    },
    getReleaseDocsInfoFailure(state, action) {
      const payload =
        action.payload && typeof action.payload === "object"
          ? action.payload
          : { message: action.payload };
      state.isLoading = false;
      state.message = payload.message ?? "";
      state.statusCode = payload.statusCode;
      state.data = null;
    },
    getReleaseDocsInfoReset(state) {
      state.isLoading = false;
      state.message = "";
      state.data = null;
      state.error = "";
      state.statusCode = undefined;
    },
  },
});

export const getReleaseDocsHandler =
  (data, options = {}) =>
  async (dispatch) => {
  try {
    dispatch(getReleaseDocsAction.getReleaseDocsInfo());
    const response = await getReleaseDocListAPI(data, options);
    dispatch(getReleaseDocsAction.getReleaseDocsInfoSuccess(response));
  } catch (e) {
    const failurePayload =
      e && typeof e === "object" && "message" in e
        ? e
        : { message: e || "Something went wrong." };
    dispatch(getReleaseDocsAction.getReleaseDocsInfoFailure(failurePayload));
  }
};
export default getReleaseDocsSlice.reducer;
export const getReleaseDocsAction = getReleaseDocsSlice.actions;
